export const getCaseStatus = (value) => {
    switch (value) {
        case "0":
            return "Open";
        case "10":
            return "Escalated";
        case "20":
            return "In Review";
        case "30":
            return "Closed as Near Miss";
        case "40":
            return "Closed";
        case "50":
            return "Best Execution Exception";
        default:
            return value;
    }
};

export const getCaseStatusColor = (status) => {
    switch (status) {
        case 0:
            return "gray-open";
        case 10:
            return "orange";
        case 20:
            return "navy";
        case 30:
            return "success-color";
        case 40:
            return "success-color";
        case 50:
            return "error-color";
        default:
            return "";
    }
};

export const textStatusColorChoice = (status) => {
    switch (status) {
        case "Open":
            return "gray-open";
        case "Escalated":
            return "orange";
        case "In Review":
            return "navy";
        case "Closed as Near Miss":
            return "success-color";
        case "Closed ":
            return "success-color";
        case "Best Execution Exception":
            return "error-color";
        default:
            return;
    }
};
